/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Quick Add (product grid cards)
 *
 * Lives here -- rather than in an inline <script> inside snippets/quick-add.liquid --
 * because several of the grids that render quick-add buttons (product recommendations,
 * recently viewed, the homepage tabbed collection custom-liquid blocks after their first
 * render) inject their markup via innerHTML/AJAX. Browsers never execute <script> tags
 * that arrive via innerHTML, so a listener defined there would silently never attach.
 * This file loads as a real <script src>, so it always runs, and delegated listeners on
 * `document` catch clicks on quick-add buttons no matter how/when they were inserted.
 */
(function () {
  function closeAllPanels(except) {
    document.querySelectorAll('.quick-add.is-open').forEach(function (el) {
      if (el !== except) {
        el.classList.remove('is-open');
        var toggle = el.querySelector('[data-quick-add-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function openCartDrawer() {
    var trigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (trigger) trigger.click();
  }

  function addVariantToCart(variantId, sizeButton) {
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (item) {
        if (item && item.status && item.status >= 400) {
          throw new Error(item.description || 'Unable to add to cart');
        }

        if (sizeButton) {
          sizeButton.classList.add('quick-add__size--added');
          setTimeout(function () {
            sizeButton.classList.remove('quick-add__size--added');
          }, 1200);
        }

        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: item, quantity: 1 },
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        setTimeout(openCartDrawer, 150);
      })
      .catch(function () {
        /* fail silently; consider a toast/error state in future */
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var wrapper = toggle.closest('[data-quick-add]');
      var isOpen = wrapper.classList.contains('is-open');
      closeAllPanels(isOpen ? null : wrapper);
      wrapper.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
      return;
    }

    var sizeBtn = e.target.closest('[data-quick-add-size]');
    if (sizeBtn) {
      e.preventDefault();
      if (sizeBtn.hasAttribute('disabled')) return;
      addVariantToCart(sizeBtn.getAttribute('data-variant-id'), sizeBtn);
      return;
    }

    var singleBtn = e.target.closest('[data-quick-add-single]');
    if (singleBtn) {
      e.preventDefault();
      addVariantToCart(singleBtn.getAttribute('data-variant-id'), null);
      return;
    }

    if (!e.target.closest('[data-quick-add]')) {
      closeAllPanels(null);
    }
  });
})();

/**
 * Active filter chips + badge live-refresh (collection page)
 *
 * Prestige's own native collection filter/sort AJAX (theme.js) already swaps the
 * product grid and the two filter forms (#collection-filters-sidebar-form /
 * #collection-filters-drawer-form) after a filter changes -- confirmed working via
 * the native `[name^="filter."]` delegated change listener it registers on the
 * collection section. It has no concept of the .ActiveFilters chip row though,
 * since that's a Kynd/Impulse-style addition layered on top of stock Prestige, so
 * it's left stale after an AJAX filter change until a full page reload. This keeps
 * it in sync by watching for the native reload to finish (it always replaces
 * .CollectionInner__Products' contents) and then re-fetching just enough markup to
 * refresh the chip row, without touching theme.js itself.
 */
(function () {
  var section = document.querySelector('section[data-section-type="collection"]');
  if (!section) return;

  var productsEl = section.querySelector('.CollectionInner__Products');
  if (!productsEl) return;

  var sectionId;
  try {
    sectionId = JSON.parse(section.getAttribute('data-section-settings') || '{}').sectionId;
  } catch (e) {
    sectionId = null;
  }
  if (!sectionId) return;

  function refreshActiveFilters() {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        var freshActiveFilters = temp.querySelector('.ActiveFilters');
        var liveActiveFilters = section.querySelector('.ActiveFilters');

        if (freshActiveFilters && liveActiveFilters) {
          liveActiveFilters.innerHTML = freshActiveFilters.innerHTML;
        } else if (freshActiveFilters && !liveActiveFilters) {
          var filterBar = section.querySelector('.FilterBar');
          if (filterBar) filterBar.insertAdjacentElement('afterend', freshActiveFilters);
        } else if (!freshActiveFilters && liveActiveFilters) {
          liveActiveFilters.remove();
        }
      })
      .catch(function () {
        /* fail silently -- chips just stay stale until next full reload */
      });
  }

  var debounceTimer;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refreshActiveFilters, 150);
  });
  observer.observe(productsEl, { childList: true });
})();
